import { Stack } from '@heathmont/moon-components';
import { Caption } from '@heathmont/moon-core';
import Translate from '~/client/shared/i18n/Translate';
import RecentGrid from './styles/RecentGrid';
import useRecentArticles from './useRecentArticles';
import BlogArticle from '../BlogArticle';

type Props = { section?: string };

const RecentArticles: FC<Props> = ({ section }) => {
  const { articles, loading } = useRecentArticles({ section });

  if (!articles?.length || loading) {
    return null;
  }

  return (
    <Stack>
      <Caption>
        <Translate id="blog.recent_posts" />
      </Caption>
      <RecentGrid>
        {articles?.map(({ node }) => (
          <BlogArticle key={node?.id} article={node} size="small" />
        ))}
      </RecentGrid>
    </Stack>
  );
};

export default RecentArticles;
